export default [
    {
        path: 'agendamento-exame-retroativo',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-agendamento-exame-retroativo' */
            '@/views/exame-laboratorial/agendamento-exame-retroativo/Index'
        ),
        redirect: 'agendamento-exame-retroativo/index',
        children: [
            {
                name: 'exame-laboratorial-agendamento-exame-retroativo-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-agendamento-exame-retroativo' */
                    '@/views/exame-laboratorial/agendamento-exame-retroativo/List.vue'
                ),
            },
            {
                name: 'exame-laboratorial-agendamento-exame-retroativo-create',
                path: 'create/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-agendamento-exame-retroativo' */
                    '@/views/exame-laboratorial/agendamento-exame-retroativo/Form.vue'
                ),
            },
        ],
    },
]